import React, { useContext, useState, useEffect } from "react";
import UsagePoolWidget from "../../../components/widgets/UsagePoolWidget";
import DataContext from "../../../context/data/dataContext";
import CalculateCustomerUsagePool from "../../../utils/CalculateCustomerUsagePool";

const AttUsagePoolWidget = () => {
  const { connections } = useContext(DataContext);
  const [carrierPoolStatus, setCarrierPoolStatus] = useState(null);

  useEffect(() => {
    if (connections !== null) {
      const poolStatusData = CalculateCustomerUsagePool(connections, "AT&T");
      setCarrierPoolStatus(poolStatusData);
    }
    //eslint-disable-next-line
  }, [connections]);

  return <UsagePoolWidget title="AT&T" carrierPoolStatus={carrierPoolStatus} />;
};

export default AttUsagePoolWidget;
